import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { ApiUrl } from 'Services/Services'; // Adjust this path based on your setup
import { toast } from 'react-toastify';



function Toppings() {
  const [topping, setTopping] = useState({
    name: '',
    price: '',
    categories: [],
  });

  const [categoryOptions, setCategoryOptions] = useState([]);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/category`);
        const data = response.data.data;

        const options = data.map((cat) => ({
          value: cat.id,
          label: cat.title,
        }));

        setCategoryOptions(options);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTopping((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategoryChange = (selectedOptions) => {
    setTopping((prev) => ({
      ...prev,
      categories: selectedOptions || [],
    }));
  };

  const handleSubmit = async () => {
    const payload = {
      name: topping.name,
      price: parseFloat(topping.price),
      categoryIds: topping.categories.map((cat) => cat.value),
    };

    console.log('Submitting topping:', payload);

    try {
      await axios.post(`${ApiUrl}/topping`, payload);
      toast.success('Topping saved')
      setTopping({ name: '', price: '', categories: [] });
    } catch (err) {
      console.error('Error saving topping:', err);
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto bg-white rounded-xl shadow-md space-y-6 mt-8">
      <h2 className="text-2xl font-bold">Add Topping</h2>

      <div className="space-y-4">
        <input
          name="name"
          value={topping.name}
          onChange={handleInputChange}
          placeholder="Topping Name (e.g. Cheese)"
          className="w-full border px-4 py-2 rounded-md"
        />

        <input
          name="price"
          type="number"
          value={topping.price}
          onChange={handleInputChange}
          placeholder="Price"
          className="w-full border px-4 py-2 rounded-md"
        />

        <Select
          isMulti
          name="categories"
          value={topping.categories}
          options={categoryOptions}
          className="basic-multi-select"
          classNamePrefix="select"
          placeholder="Select Categories"
          onChange={handleCategoryChange}
        />

        <button
          onClick={handleSubmit}
          className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
        >
          Save Topping
        </button>
      </div>
    </div>
  );
}

export default Toppings;
